import Nullstack from 'nullstack';
export default function IconClipboardData({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-clipboard-data",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), "   ", Nullstack.element("rect", {
    x: "9",
    y: "3",
    width: "6",
    height: "4",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M9 17v-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v-1"
  }), "   ", Nullstack.element("path", {
    d: "M15 17v-2"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v-1"
  }), " ");
}